import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PropertyDto } from '@workspace/data-types';
import { EtxeEnumDisplayPipe } from '../../pipes/etxe-enum-display.pipe';
import { PropertyHoverPreviewDirective } from '../property-hover-card/property-hover-preview.directive';

@Component({
  selector: 'etxe-property-compact-summary',
  imports: [
    DecimalPipe,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    PropertyHoverPreviewDirective,
    EtxeEnumDisplayPipe,
  ],
  templateUrl: './property-compact-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyCompactSummaryComponent {
  readonly property = input.required<PropertyDto>();
  readonly viewDetails = output<void>();

  readonly coverPhotoUrl = computed<string | null>(() => {
    const p = this.property();
    const cover = p?.media?.coverPhoto;
    if (cover && typeof cover === 'object' && 'url' in cover) {
      return (cover as { url?: string }).url || null;
    }
    const firstPhoto = p?.media?.photos?.[0]?.file;
    if (firstPhoto && typeof firstPhoto === 'object' && 'url' in firstPhoto) {
      return (firstPhoto as { url?: string }).url || null;
    }
    return null;
  });

  readonly reference = computed<string | null>(() => {
    return this.property()?.definition?.reference || null;
  });

  readonly sellingPriceEuros = computed<number | null>(() => {
    const cents = this.property()?.financials?.sellingPriceCents;
    return cents ? cents / 100 : null;
  });

  readonly totalPieces = computed<number>(() => {
    const interior = this.property()?.characteristics?.interior;
    if (!interior) return 0;
    return (interior.rooms?.length ?? 0) + (interior.bedroom?.length ?? 0);
  });

  readonly habitableSurface = computed<number | null>(() => {
    return this.property()?.keyInfo?.surface?.habitable ?? null;
  });

  readonly city = computed<string | null>(() => {
    return this.property()?.location?.address?.city || null;
  });

  readonly zipCode = computed<string | null>(() => {
    return this.property()?.location?.address?.zipCode || null;
  });

  onCardClick(): void {
    this.viewDetails.emit();
  }
}
